"use client";

import styles from "./ForgotPasswordPageContainer.module.scss";
import { ReactNode } from "react";

/**
 * ForgotPasswordPageContainer Component
 *
 * Wrapper component for main forgot password content area.
 * Provides styling and layout structure for password reset form and header.
 */
export const ForgotPasswordPageContainer = ({
  children,
}: {
  children: ReactNode;
}) => {
  return <div className={styles["comp"]}>{children}</div>;
};
